import { PanelBackgrounds } from "@flightpath/coreui/dist/ui/Panel";
import { Panel } from "../../../../../../components/ui/Panel";
import { PieChart } from "../../../../../../components/widgets/pie/pie";
import { useEffect, useState } from "react";
import { MapReportingModel } from "./MapReporting_model";
import { useCurrentOrganisationId } from "../../../../../../services/local/organisationContext/OrganisationContextModel";
import { PositionedSpinner } from "../../../../../../components/ui/PositionedSpinner";
import { observer } from "mobx-react-lite";
import { ragColourArray } from "../../../../dashboard/actions/ActionPies";
import { ReportingTitle } from "../../../../projects/view/components/ReportingPie";
import { IF } from "../../../../../../components/hoc/If";

export type ProjectWithImpactCountPie = {
  color: string;
  id: number;
  projectName: string;
  impactCount: number;
};

interface MapReportingProps {
  selectedPlaceId: number;
}

export const MapReporting: React.FC<MapReportingProps> = observer(({ selectedPlaceId }) => {
  const organisationId = useCurrentOrganisationId();
  const [model] = useState(() => new MapReportingModel(organisationId, selectedPlaceId));

  useEffect(() => {
    model.onMount();
    return model.onUnmount;
  }, [model]);

  return (
    <div className="container-fluid">
      <div className="d-flex justify-content-center my-3 align-items-center">
        <h1>Places Reporting Modal</h1>
      </div>
      <div className="row">
        <div className="col-12">
          <Panel.Panel background={Panel.PanelBackgrounds.BG_WHITE} hasShadow={true} className="p-2 mb-5">
            <ReportingTitle title={"Impact count by project"} />
            <div style={{ height: "50vh" }}>
              <IF condition={model.isLoading}>
                <PositionedSpinner />
              </IF>
              <IF condition={!model.isLoading && model.placeImpactProjectPieChartData.length === 0}>
                <h3 className="mt-3">There was no data found for this parameters</h3>
              </IF>
              <IF condition={!model.isLoading}>
                <PieChart
                  data={model.placeImpactProjectPieChartData}
                  tooltipFn={PieTooltip}
                  colors={ragColourArray}
                  hasLinkLabels={true}
                  margin={{
                    top: 50,
                    right: 0,
                    bottom: 50,
                    left: 0
                  }}
                />
              </IF>
            </div>
          </Panel.Panel>
        </div>
      </div>
    </div>
  );
});

const PieTooltip = props => {
  return (
    <Panel.Panel background={PanelBackgrounds.BG_WHITE} hasBorderRadius={true} className="p-2">
      <span className="mb-0 body">
        {props.label}: {props.value}
      </span>
    </Panel.Panel>
  );
};
